<template>
  <el-select
    v-model="modelValue"
    :placeholder="$l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'"
    filterable
    clearable
    @change="onChange"
    @visible-change="onVisibleChange"
    style="width:100%"
    :size="size"
    popper-class="hscode-select"
    :popper-append-to-body="false"
    :filter-method="filterMethod"
    default-first-option
    no-data-text="无匹配HSCODE"
  >
    <el-option
      v-for="item in options"
      :key="item.shipmentCustomsCode"
      :label="item.hscode"
      :value="item.hscode"
    >
      <div class="title">
        {{ `${item.hscodeName}  ${item.hscodeNameEn}` }}
      </div>
      <div class="desc">
        {{ item.hscode }}
      </div>
    </el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    hscode: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
    size: { type: String, default: 'small' },
  },
  data() {
    return {
      modelValue: '',
      data: [],
      options: [],
    }
  },
  watch: {
    hscode: {
      handler(e) {
        this.modelValue = e
      },
      immediate: true,
    },
    categoryCode() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await this.$api
        .shipmentCustomsCodeSelectApi({ categoryCode: this.categoryCode })
        .catch(() => null)
      if (!res) return
      this.data = res.body.data
      this.options = res.body.data
    },
    onChange(e) {
      if (!e) {
        this.$emit('change', {})
        return
      }
      const index = this.data.findIndex((item) => item.hscode === e)
      if (index < 0) {
        return
      }
      const val = this.data[index]
      this.$emit('change', val)
    },
    filterMethod(e) {
      if (!e) {
        this.options = this.data
        return
      }
      if (!this.data || !this.data.length) return
      this.options = this.data.filter((item) => {
        const key = `${item.hscode}${item.hscodeName}${item.hscodeNameEn}`
        return key.toLowerCase().indexOf(e.toLowerCase()) > -1
      })
    },
    onVisibleChange() {
      this.options = this.data
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .hscode-select .el-select-dropdown__item {
  font-size: 14px;
  padding: 2px 20px;
  height: 52px;
  .title {
    line-height: 28px;
  }
  .desc {
    color: #8492a6;
    font-size: 13px;
    line-height: 20px;
  }
}
</style>
